module.exports = __webpack_public_path__ + "img/clo.e4d62d78.svg";